export const mutationTypes = {
  translateIdsStart: '[integrations] translate ids start',
  translateIdsSuccess: '[integrations] translate ids success',
  translateIdsFailure: '[integrations] translate ids failure',
};

const mutations = {
  [mutationTypes.translateIdsStart]() {},
  [mutationTypes.translateIdsSuccess]() {},
  [mutationTypes.translateIdsFailure]() {},
};

export default mutations;
